<template>
  <div
    v-if="hint"
    class="content RMPE-DynamicField-Description "
    v-html="hint"
  />
</template>

<script>
export default {
  props: {
    hint: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
<style scoped lang="scss">
.RMPE-DynamicField-Description {
  word-break: break-word;
}
</style>
